export const adminSelectorTranslations = {
  title: 'Mes entreprises',
  contact_text: 'Pour ajouter une entreprise',
  contact_link: 'contactez-nous',
  accessibility: {
    current_company: 'Entreprise actuelle: %{name}',
    switch_to: 'Passer à %{name}',
    companies: 'Entreprises',
  },
};
